<template>
  <div class="home-page">
    <nav-tab></nav-tab>
    <div class="page_1">
      <video v-if="$isPC" id="video" class="p1_video"
        src="https://global-cdn.imscv.com/tewamoto/PC260612/main_compressed.mp4" alt=""></video>
      <video v-else id="video" class="p1_video"
        src="https://global-cdn.imscv.com/tewamoto/M260612/main_m_compressed.mp4"></video>
      <div v-if="$isPC" class="txt_cont">
        <div class="txt_inner">
          <div class="txt1">ELECTRIC POWER.</div>
          <div class="txt1">BUILT FOR THE WILD.</div>
          <div class="txt2">TEWA MOTO builds high-performance electric dirt bikes engineered for riders who <br> demand
            instant torque, precise control, and true off-road freedom.</div>
          <div class="btn_box">
            <div class="btn1" @click="jumpToM3">Explore M3 PRO</div>
            <div class="btn2" @click="playMainVideo">
              <img
                src="https://global-cdn.imscv.com/tewamoto%2FPC260612%2F2-Hero%20Banner%20%20Riding%20Video%2FPlay%20button_2%C3%97.svg"
                alt="">
              <div>Watch Video</div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="txt_cont">
        <div class="txt1">ELECTRIC POWER.</div>
        <div class="txt1">BUILT FOR THE WILD.</div>
        <div class="txt2">TEWA MOTO builds high-performance electric dirt bikes engineered for riders who demand instant
          torque, precise control, and true off-road freedom.</div>
        <div class="btn_box">
          <div class="btn1" @click="jumpToM3">Explore M3 PRO</div>
          <div class="btn2" @click="playMainVideo">
            <img
              src="https://global-cdn.imscv.com/tewamoto%2FPC260612%2F2-Hero%20Banner%20%20Riding%20Video%2FPlay%20button_2%C3%97.svg"
              alt="">
            <div>Watch Video</div>
          </div>
        </div>
      </div>
    </div>

    <div class="page_2" v-if="$isPC">
      <div class="txt_cont1">
        <div class="box">
          <div class="left">
            <div class="title">MOVE <br> BEYOND <br> LIMITS</div>
            <div class="txt">We don’t just build electric <br> motorcycles. <br> We redefine how electric <br> power
              moves across the wild.</div>
          </div>
          <div class="right">
            <div class="txt_box">
              <div class="title">ELECTRIC PERFORMANCE</div>
              <div class="txt">Instant torque delivery and powerful <br> acceleration built for serious off - road <br>
                riding
                performance.
              </div>
            </div>
            <div class="line"></div>
            <div class="txt_box">
              <div class="title">OFF - ROAD FREEDOM</div>
              <div class="txt">Engineered to handle mountains, <br> trails, dirt, and extreme outdoor <br> environments.
              </div>
            </div>
            <div class="line"></div>
            <div class="txt_box">
              <div class="title">CLEAN POWER SPORTS</div>
              <div class="txt">High - performance electric mobility <br> with reduced noise and <br> zero - emission
                riding
                experience.</div>
            </div>
          </div>
        </div>
      </div>

      <div class="txt_cont2">
        <img
          src="https://global-cdn.imscv.com/tewamoto%2FPC260612%2F4-M3%20PRO%20Overview%2FBLACK%20M3%20PRO_2%C3%97.png"
          alt="" class="left" />
        <div class="right">
          <img
            src="https://global-cdn.imscv.com/tewamoto%2FPC260612%2F4-M3%20PRO%20Overview%2FM3%20RRO%20LOGO-_2%C3%97.svg"
            alt="" class="m3_pro">
          <div class="t2">The electric dirt bike built for serious off - road power and next - generation <br> riding
            performance.</div>
          <div class="txt_box">
            <div class="txt_left">
              <div class="tt">21 kW</div>
              <div class="bt">Peak Power</div>
            </div>
            <div class="txt_right">
              <div class="tt">84 V</div>
              <div class="bt">Peak Voltage</div>
            </div>
          </div>
          <div class="txt_box">
            <div class="txt_left">
              <div class="tt">10.5 kW</div>
              <div class="bt">Rated Power</div>
            </div>
            <div class="txt_right">
              <div class="tt">8000 rpm</div>
              <div class="bt">Max Motor Speed</div>
            </div>
          </div>
          <div class="txt_box">
            <div class="txt_left">
              <div class="tt">Hairspin Motor</div>
              <div class="bt">Technology</div>
            </div>
            <div class="txt_right">
              <div class="tt">1C</div>
              <div class="bt">Max Charging Rate</div>
            </div>
          </div>
          <div class="btn_box">
            <div @click="jumpToM3">View M3 PRO</div>
            <div @click="jumpToDealer">Become Our Dealer</div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="page_2">
      <div class="txt_cont1_mob">
        <div class="txt_cont1">
          <div class="t1">MOVE BEYOND LIMITS</div>
          <div class="t2">We don’t just build electric motorcycles. We redefine how electric power moves across the
            wild.
          </div>
        </div>
        <div class="txt_cont2">
          <div class="t_item">
            <div class="t1">ELECTRIC PERFORMANCE</div>
            <div class="t2">Instant torque delivery and powerful acceleration built for serious off - road riding
              performance.
            </div>
          </div>
          <div class="line"></div>
          <div class="t_item">
            <div class="t1">OFF - ROAD FREEDOM</div>
            <div class="t2">Engineered to handle mountains, trails, dirt, and extreme outdoor environments.</div>
          </div>
          <div class="line"></div>
          <div class="t_item">
            <div class="t1">CLEAN POWER SPORTS</div>
            <div class="t2">We don’t just build electric motorcycles. We redefine how electric power moves across the
              wild.</div>
          </div>
        </div>
      </div>
      <div class="txt_cont2_mob">
        <img
          src="https://global-cdn.imscv.com/tewamoto%2FPC260612%2F4-M3%20PRO%20Overview%2FM3%20RRO%20LOGO-_2%C3%97.svg"
          alt="" class="m3_pro">
        <div class="t2">The electric dirt bike built for serious off - road power and next - generation riding
          performance.</div>
        <img
          src="https://global-cdn.imscv.com/tewamoto%2FPC260612%2F4-M3%20PRO%20Overview%2FBLACK%20M3%20PRO_2%C3%97.png"
          alt="" class="moto_img" />
        <div class="txt_box">
          <div class="txt_left">
            <div class="tt">21 kW</div>
            <div class="bt">Peak Power</div>
          </div>
          <div class="txt_right">
            <div class="tt">84 V</div>
            <div class="bt">Peak Voltage</div>
          </div>
        </div>
        <div class="txt_box">
          <div class="txt_left">
            <div class="tt">10.5 kW</div>
            <div class="bt">Rated Power</div>
          </div>
          <div class="txt_right">
            <div class="tt">8000 rpm</div>
            <div class="bt">Max Motor Speed</div>
          </div>
        </div>
        <div class="txt_box">
          <div class="txt_left">
            <div class="tt">Hairspin Motor</div>
            <div class="bt">Technology</div>
          </div>
          <div class="txt_right">
            <div class="tt">1C</div>
            <div class="bt">Max Charging Rate</div>
          </div>
        </div>
        <div class="btn_box">
          <div class="bt1" @click="jumpToM3">View M3 PRO</div>
          <div class="bt2" @click="jumpToDealer">Become Our Dealer</div>
        </div>
      </div>
    </div>
    <div class="page_3">
      <div class="txt_cont">
        <div class="lt">TESTED BY RIDERS. <br>
          SEEN BY THE WORLD.</div>
        <div class="rt" v-if="$isPC">Explore real-world ride reviews, performance testing, and riding experiences shared
          <br> by
          creators and off-road riders across the electric moto community.
        </div>
        <div v-else class="rt">Explore real-world ride reviews, performance testing, and riding experiences shared by
          creators and
          off-road riders across the electric moto community.</div>
      </div>
      <div class="video_box">
        <div class="video" v-for="(item,index) in videoList" :key="index">
          <div class="img-wrapper" @click="toUtoB(index)">
            <img :src="item.url" alt="">
          </div>
          <div class="tips">{{item.text}}</div>
        </div>
        <div v-if="$isMobile" class="jiantou" @click="jumpInstagram">
          <span>Explore More on Social Media</span>
          <img src="https://global-cdn.imscv.com/tewamoto%2FPC260612%2F5-Media%20Features%2FArrow_2%C3%97.svg" alt="">
        </div>
      </div>
      <div v-if="$isPC" class="jiantou" @click="jumpInstagram"><span>Explore More on Social Media</span><img
          src="https://global-cdn.imscv.com/tewamoto%2FPC260612%2F5-Media%20Features%2FArrow_2%C3%97.svg" alt=""></div>
    </div>
    <div class="page_4" v-if="$isPC">
      <div class="t1">BECOME OUR DEALER</div>
      <div class="t2">Join the TEWA MOTO dealer network and bring high-performance electric powersports <br> products to
        riders in your
        market.</div>
      <div class="icon_list">
        <div class="list_item" v-for="(item,index) in iconList" :key="index">
          <img :src="item.url" alt="">
          <div>{{ item.text }}</div>
        </div>
      </div>
      <div class="btn_box">
        <div class="btn_l" @click="jumpToDealer">Become Our Dealer ></div>
        <div class="btn_r" @click="jumpToDealer">Find a Dealer</div>
      </div>
    </div>
    <div class="page_4" v-else>
      <div class="t1">BECOME OUR DEALER</div>
      <div class="t2">Join the TEWA MOTO dealer network and bring high-performance electric powersports products to
        riders in your market.</div>
      <div class="icon_list">
        <div class="list_item" v-for="(item,index) in iconList" :key="index">
          <img :src="item.url" alt="">
          <div>{{ item.text }}</div>
        </div>
      </div>
      <div class="btn_box">
        <div class="btn_l" @click="jumpToDealer">Become Our Dealer ></div>
        <div class="btn_r" @click="jumpToDealer">Find a Dealer</div>
      </div>
    </div>
    <footerTemp></footerTemp>
  </div>
</template>

<script>
  import navTab from '@/components/navTab.vue'
  import footerTemp from '@/components/footer.vue'
  export default {
    name: 'HomePage',
    components: {
      navTab,
      footerTemp
    },
    data () {
      return {
        bannerIndex: 0,
        isVideoPlaying: false,
        startX: 0,
        endX: 0,
        iconList: [
          {
            url: 'https://global-cdn.imscv.com/tewamoto%2FPC260612%2F6-Dealer%2FICON-1_2%C3%97.svg',
            text: 'High-performance electric dirt bike lineup'
          },
          {
            url: 'https://global-cdn.imscv.com/tewamoto%2FPC260612%2F6-Dealer%2FICON-2_2%C3%97.svg',
            text: 'Future electric PWC and UTV product expansion'
          },
          {
            url: 'https://global-cdn.imscv.com/tewamoto%2FPC260612%2F6-Dealer%2FICON-3_2%C3%97.svg',
            text: 'Brand content and marketing support'
          },
          {
            url: 'https://global-cdn.imscv.com/tewamoto%2FPC260612%2F6-Dealer%2FICON-4_2%C3%97.svg',
            text: 'Product training and dealer sales support'
          },
          {
            url: 'https://global-cdn.imscv.com/tewamoto%2FPC260612%2F6-Dealer%2FICON-5_2%C3%97.svg',
            text: 'Long-term electric powersports growth opportunity'
          },
        ],
        videoList: [
          {
            url: 'https://global-cdn.imscv.com/tewamoto/MediaVideo/Media-Video-1.jpg',
            text: 'Testing the 2026 Tewa Moto M3 Pro Electric Dirt Bike!'
          },
          {
            url: 'https://global-cdn.imscv.com/tewamoto/MediaVideo/Media-Video-2.jpg',
            text: 'Does This NEW E-Moto Actually Ride Like A Gas Bike!'
          },
          {
            url: 'https://global-cdn.imscv.com/tewamoto/MediaVideo/Media-Video-3.jpg',
            text: 'TESTING TEWA MOTO M3Pro'
          },
          {
            url: 'https://global-cdn.imscv.com/tewamoto/MediaVideo/Media-Video-4.jpg',
            text: 'Riding Electric Dirtbike in the DESERT!! (Tewa M3 PRO)'
          },
          {
            url: 'https://global-cdn.imscv.com/tewamoto/MediaVideo/Media-Video-5.jpg',
            text: 'First ride on my Electric 2 stroke!! '
          }

        ],
        promptList: [
          { text1: 'PRO CHASSIS', text2: 'Professional Frame Design', text3: ' Motorcycle Grade Components' },
          { text1: 'PRO POWER', text2: '21KW Peak Power', text3: '720 N.m Wheel Torque' },
          { text1: 'PRO PERFORMANCE', text2: '2s 0-30 mph', text3: ' 60 mph Top Speed' }
        ],
        bannerList: [
          'https://global-cdn.imscv.com/tewamoto/v3/HOME-2-1.jpg',
          'https://global-cdn.imscv.com/tewamoto/v3/HOME-2-2.jpg',
          'https://global-cdn.imscv.com/tewamoto/v3/HOME-2-3.jpg'
        ],
        bannerListMobile: [
          'https://global-cdn.imscv.com/tewamoto/mobile-v3/HOME-2-1.jpg',
          'https://global-cdn.imscv.com/tewamoto/mobile-v3/HOME-2-2.jpg',
          'https://global-cdn.imscv.com/tewamoto/mobile-v3/HOME-2-3.jpg'
        ],
        timer: null,
      }
    },
    mounted () {
      window.scrollTo(0, 0) //  回到顶部
      this.changeBanner();
    },
    beforeDestroy () {
      clearInterval(this.timer)
    },
    methods: {
      playMainVideo () {
        // 播放视频
        // 获取视频元素
        const videoElement = document.getElementById('video');

        if (videoElement) {
          // 如果视频正在播放，则暂停
          if (!videoElement.paused) {
            videoElement.pause();
            this.isVideoPlaying = false;
            return;
          }

          // 重置其他视频的播放状态
          const allVideos = document.querySelectorAll('video');
          allVideos.forEach(video => {
            if (video !== videoElement) {
              video.pause();
            }
          });

          // 尝试播放当前视频
          videoElement.currentTime = 0; // 从头开始播放

          const playPromise = videoElement.play();

          if (playPromise !== undefined) {
            playPromise.then(() => {
              this.isVideoPlaying = true;
              console.log('视频开始播放');
            }).catch(error => {
              console.warn('视频播放失败:', error);
            });
          }
          //  监听视频播放完成
          videoElement.addEventListener('ended', () => {
            console.log('视频播放完成');
            this.isVideoPlaying = false;
            videoElement.currentTime = 0; // 从头开始播放
          });
        }

      },
      jumpInstagram () {
        window.open('https://www.instagram.com/tewamoto_usa/', '_blank');
      },
      toUtoB (idx) {
        let youtubeUrl = '';
        console.log('label', idx);
        switch (idx) {
          case 0:
            youtubeUrl = 'https://www.youtube.com/watch?v=GGY2BPTvEvs';
            break;
          case 1:
            youtubeUrl = 'https://www.youtube.com/watch?v=JGD8fAjrYWE';
            break;
          case 2:
            youtubeUrl = 'https://www.youtube.com/watch?v=ahjUbhcw21M';
            break;
          case 3:
            youtubeUrl = 'https://www.youtube.com/watch?v=Tlv7g_BZ5ts';
            break;
          case 4:
            youtubeUrl = 'https://www.youtube.com/watch?v=VIDEO_ID_FOR_FIFTH_VIDEO'; // 需要替换为实际的YouTube视频ID
            break;
          default:
        }

        // 使用window.open打开新窗口，避免被浏览器拦截
        window.open(youtubeUrl, '_blank');
      },
      jumpToM3 () {
        // 跳转M3
        this.$router.push('/M3SERIES')
      },
      jumpToDealer () {
        // 跳转经销商
        this.$router.push('/contact')
      },
      changeBanner () {
        if (this.timer) {
          clearInterval(this.timer);
        }
        this.timer = setInterval(() => {
          this.bannerIndex++;
          if (this.bannerIndex > 2) {
            this.bannerIndex = 0;
          }
        }, 2500);
      },

      handleIndicatorClick (index) {
        this.bannerIndex = index
        clearInterval(this.timer)
        this.changeBanner()
      },
      onTouchStart (e) {
        this.startX = e.changedTouches[0].clientX
      },

      onTouchEnd (e) {
        this.endX = e.changedTouches[0].clientX
        const distance = this.endX - this.startX

        // 滑动阈值（防止误触）
        if (Math.abs(distance) < 50) return

        // 左滑  下一张
        if (distance < 0) {
          this.bannerIndex++
          if (this.bannerIndex > 2) this.bannerIndex = 0
        }

        // 右滑  上一张
        if (distance > 0) {
          this.bannerIndex--
          if (this.bannerIndex < 0) this.bannerIndex = 2
        }

        // 滑动后可选：停止自动轮播
        clearInterval(this.timer)
        // 或者想滑完继续自动轮播 → 打开：
        this.changeBanner()
      }
    }
  }
</script>

<style scoped lang="scss">
  img {
    display: block;
  }

  @media (min-width: 769px) {
    .home-page {
      background: #000;
      color: #333;

      .page_1 {
        position: relative;

        .p1_video {
          width: 100%;
          height: 100%;
          display: block;
          object-fit: cover;      // 视频铺满不变形
          object-position: center;
        }

        .txt_cont {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          /* PC 宽屏：文字块右边界对齐 1440px 内容容器，避免 4K / 带鱼屏把文字推到最右 */
          padding-right: max(56px, calc((100% - 1440px) / 2));

          .txt_inner {
            width: 45%;
            max-width: 720px;       // 高分屏限制文字块最大宽度，避免一行过长
            color: #fff;
            font-family: "AlibabaPuHuiTi";

            .txt1 {
              font-weight: bold;
              font-size: 45px;
              line-height: 45px;
            }

            .txt2 {
              font-size: 12px;
              line-height: 14px;
            }

            .btn_box {
              display: flex;
              margin-top: 30px;

              .btn1 {
                background-color: #FFA400;
                color: #000;
                font-size: 14px;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 5px 10px;
                margin-right: 20px;
                cursor: pointer;
              }

              .btn2 {
                display: flex;
                align-items: center;
                justify-content: center;
                border: 1px solid #FFA400;
                box-sizing: border-box;
                white-space: nowrap;
                font-size: 14px;
                padding: 5px 10px;
                cursor: pointer;

                img {
                  width: 10px;
                  height: 10px;
                  margin-right: 5px;
                }
              }
            }
          }
        }
      }

      .page_2 {
        width: 100%;
        /* PC 宽屏：左右 padding 随视口增大，把内容压在 1440px 内居中，背景仍全宽 */
        padding: 50px max(150px, calc((100% - 1440px) / 2));
        box-sizing: border-box;
        background-color: #191919;

        .txt_cont1 {
          width: 100%;
          box-sizing: border-box;
          font-family: "AlibabaPuHuiTi";

          .box {
            display: flex;
            justify-content: center;

            .left {
              display: flex;
              align-items: center;
              padding: 20px 30px;
              box-sizing: border-box;
              background-color: #262626;
              color: #fff;
              column-gap: 15px;

              .title {
                font-size: 24px;
                font-weight: bold;
              }
            }

            .right {
              display: flex;
              align-items: center;
              background-color: #FFA400;
              padding: 20px 30px;
              column-gap: 10px;
              color: #000;

              .txt_box {
                display: flex;
                flex-direction: column;
                align-items: center;

                .title {
                  font-weight: bold;
                  font-size: 10px;
                }

              }

              .line {
                width: 1px;
                height: 100%;
                border-right: 1px solid #000;
              }
            }
          }
        }

        .txt_cont2 {
          display: flex;
          justify-content: center;
          width: 100%;
          box-sizing: border-box;
          margin-top: 50px;

          .left {
            width: 50%;
            box-sizing: border-box;
          }

          .right {
            flex: 1;
            font-family: "AlibabaPuHuiTi";
            color: #fff;
            box-sizing: border-box;
            padding-right: 70px;

            .m3_pro {
              width: 170px;
            }

            .t2 {
              font-size: 12px;
              margin-top: 20px;
              line-height: 13px;
            }

            .txt_box {
              display: flex;
              border-bottom: 1px solid #424242;
              padding-bottom: 5px;
              margin-top: 20px;
              column-gap: 30px;

              .txt_left {
                width: 45%;
              }

              .tt {
                color: #FFA400;
                font-size: 14px;
                font-weight: bold;
              }
            }
          }

          .btn_box {
            display: flex;
            font-family: "AlibabaPuHuiTi";
            font-size: 12px;
            column-gap: 30px;
            margin-top: 20px;
            text-align: center;

            div {
              padding: 5px 0;
              cursor: pointer;
            }

            div:first-child {
              background-color: #FFA400;
              color: #000;
              flex: 1;
            }

            div:last-child {
              border: 1px solid #FFA400;
              color: #fff;
              flex: 1;
            }
          }
        }
      }

      .page_3 {
        width: 100%;
        box-sizing: border-box;
        font-family: "AlibabaPuHuiTi";
        background-color: #000;

        .txt_cont {
          display: flex;
          padding: 100px max(100px, calc((100% - 1440px) / 2)) 20px;
          box-sizing: border-box;
          justify-content: space-between;

          .lt {
            font-size: 24px;
            color: #fff;
            font-weight: bold;
          }

          .rt {
            font-size: 16px;
            color: #fff;
            line-height: 22px;
            opacity: 0.8;
          }
        }

        .video_box {
          width: 100%;
          box-sizing: border-box;
          display: flex;
          column-gap: 20px;
          justify-content: space-between;

          .video {
            flex: 1;
            position: relative;
            cursor: pointer;
            overflow: hidden;
            display: flex;
            flex-direction: column;

            .img-wrapper {
              width: 100%;
              position: relative;
              cursor: pointer;
              overflow: hidden;
            }

            img {
              width: 100%;
              height: auto;
              display: block;
            }

            div {
              text-align: center;
              font-size: 12px;
              color: #f0f0f0;
              background-color: #262626;
              padding: 20px 0;
              z-index: 2;
            }

            .tips {
              flex: 1;
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }

          .img-wrapper::after {
            content: '';
            position: absolute;
            inset: 0;
            background:
              url('https://global-cdn.imscv.com/tewamoto%2FPC260612%2F5-Media%20Features%2FVideo%20play%20button_2%C3%97.svg') no-repeat center / 30px 30px,
              rgba(0, 0, 0, 0.4);
            transition: background-color 0.3s;
          }

          .img-wrapper:hover::after {
            background-color: rgba(0, 0, 0, 0.6);
          }

        }

        .jiantou {
          display: flex;
          font-family: "AlibabaPuHuiTi";
          font-size: 20px;
          color: #FFA400;
          padding: 30px max(100px, calc((100% - 1440px) / 2));
          box-sizing: border-box;
          cursor: pointer;

          img {
            width: 20px;
            height: auto;
            margin-left: 10px;
          }
        }
      }

      .page_4 {
        width: 100%;
        height: auto;
        /* PC 宽屏：左右 padding 随视口增大，内容压在 1440px 内居中 */
        padding: 100px max(120px, calc((100% - 1440px) / 2));
        box-sizing: border-box;
        background: url('https://global-cdn.imscv.com/tewamoto%2FPC260612%2F6-Dealer%2FDealer_bg_pc_2%C3%97.jpg') no-repeat center;
        background-size: cover;   // 背景图按比例裁切铺满，宽屏不拉伸变形
        font-family: "AlibabaPuHuiTi";
        color: #fff;

        .t1 {
          font-size: 30px;
          font-weight: bold;
          text-align: center;
        }

        .t2 {
          font-size: 12px;
          text-align: center;
          margin-top: 20px;
        }

        .icon_list {
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          column-gap: 120px;
          margin-top: 50px;

          .list_item {
            display: flex;
            flex-direction: column;
            align-items: center;

            img {
              width: 100px;
              height: 50px;
              object-fit: contain; // 图标按比例完整显示，不变形
            }

            div {
              margin-top: 30px;
              text-align: center;
              font-size: 12px;   // 明确字号，避免继承根字号 37.5px 导致巨大
              line-height: 1.4;
            }
          }

        }

        .btn_box {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 50px;
          font-family: "AlibabaPuHuiTi";
          font-size: 18px;
          color: #000;
          font-weight: bold;
          column-gap: 30px;
          cursor: pointer;

          .btn_l {
            background-color: #FFA400;
            padding: 5px 20px;
          }

          .btn_r {
            background-color: #fff;
            padding: 5px 60px;
          }
        }
      }
    }
  }

  /* 平板档 769~1024：沿用 PC 布局，收窄内边距、略缩字号，避免内容顶边/太空 */
  @media (min-width: 769px) and (max-width: 1024px) {
    .home-page {
      .page_1 {
        .txt_cont {
          padding-right: 0;   // 平板宽度 < 1440，无需宽屏居中约束
        }

        .txt_cont .txt_inner {
          width: 60%;

          .txt1 {
            font-size: 36px;
            line-height: 38px;
          }
        }
      }

      .page_2 {
        padding: 40px 50px;

        .txt_cont2 .right {
          padding-right: 30px;
        }
      }

      .page_3 {
        .txt_cont {
          padding: 60px 50px 20px;
        }

        .jiantou {
          padding: 24px 50px;
        }
      }

      .page_4 {
        padding: 60px 50px;
      }
    }
  }

  @media (max-width: 768px) {
    .home-page {
      background: #000;
      color: #333;

      .page_1 {
        position: relative;

        .p1_video {
          width: 100%;
          height: auto;
          display: block;
        }

        .txt_cont {
          width: 100%;
          height: 100%;
          box-sizing: border-box;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          font-family: "AlibabaPuHuiTi";
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          .txt1 {
            font-size: 30px;
            font-weight: bold;
            color: #fff;
          }

          .txt2 {
            text-align: center;
            font-size: 12px;
            color: #fff;
            opacity: 0.9;
            margin-top: 15px;
          }

          .btn_box {
            display: flex;
            column-gap: 20px;
            margin-top: 20px;

            .btn1 {
              background-color: #FFA400;
              padding: 5px 10px;
            }

            .btn2 {
              display: flex;
              justify-content: center;
              align-items: center;
              padding: 5px 10px;
              box-sizing: border-box;
              border: 1px solid #FFA400;
              color: #fff;

              img {
                width: 10px;
                height: 10px;
                margin-right: 5px;
              }
            }
          }
        }
      }

      .page_2 {
        width: 100%;
        font-family: "AlibabaPuHuiTi";
        padding: 20px;
        box-sizing: border-box;
        background-color: #121212;

        img {
          width: 100%;
          height: auto;
        }

        .txt_cont1_mob {
          width: 100%;
          height: auto;

          .txt_cont1 {
            background-color: #212121;
            text-align: center;
            color: #fff;
            padding: 20px 10px;
            box-sizing: border-box;

            .t1 {
              font-size: 26px;
              font-weight: bold;
            }

            .t2 {
              font-size: 9px;
              opacity: .9;
            }
          }

          .txt_cont2 {
            background-color: #FFA400;
            display: flex;
            justify-content: center;
            align-items: center;
            column-gap: 8px;
            padding: 20px 10px;
            box-sizing: border-box;

            .t1 {
              font-weight: bold;
              color: #000;
              text-align: center;
            }

            .t2 {
              font-size: 9px;
              color: #333;
            }

            .line {
              align-self: stretch;
              border-right: 1px solid #333;
            }
          }
        }

        .txt_cont2_mob {
          margin-top: 50px;

          .m3_pro {
            width: 160px;
          }

          .t2 {
            color: #fff;
            margin: 10px 0 30px;
            line-height: 10px;
            opacity: .8;
          }

          .txt_box {
            display: flex;
            border-bottom: 1px solid #333;
            padding: 10px 0;

            .txt_left {
              width: 50%;
            }

            .tt {
              color: #FFA400;
              font-weight: bold;
              font-size: 14px;
            }

            .bt {
              color: #fff;
              opacity: .8;
            }
          }

          .btn_box {
            display: flex;
            justify-content: space-between;
            column-gap: 10px;

            div {
              font-weight: bold;
              box-sizing: border-box;
              text-align: center;
              padding: 5px 0;
            }

            .bt1 {
              background-color: #FFA400;
              flex: 1;
            }

            .bt2 {
              flex: 1;
              border: 1px solid #FFA400;
              color: #fff;
            }
          }
        }
      }

      .page_3 {
        width: 100%;
        padding: 30px 20px;
        box-sizing: border-box;
        font-family: "AlibabaPuHuiTi";

        .lt {
          color: #fff;
          font-weight: bold;
          font-size: 24px;
        }

        .rt {
          margin: 10px 0;
          color: #fff;
          line-height: 10px;
        }

        .video_box {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          align-items: stretch;
          column-gap: 10px;
          row-gap: 20px;

          .video {
            width: calc(50% - 10px);
            display: flex;
            flex-direction: column;

            img {
              width: 100%;
            }

            .img-wrapper {
              position: relative;
            }

            .img-wrapper::after {
              content: '';
              position: absolute;
              inset: 0;
              background:
                url('https://global-cdn.imscv.com/tewamoto%2FPC260612%2F5-Media%20Features%2FVideo%20play%20button_2%C3%97.svg') no-repeat center / 30px 30px,
                rgba(0, 0, 0, 0.4);
              transition: background-color 0.3s;
            }

            .tips {
              flex: 1;
              color: #999;
              background-color: #212121;
              display: flex;
              align-items: center;
              justify-content: center;
              text-align: center;
              padding: 5px 0;
            }
          }

          .jiantou {
            width: calc(50% - 10px);
            display: flex;
            align-items: flex-end;
            color: #FFA400;

            img {
              width: 20px;
              height: 20px;
            }
          }
        }
      }

      .page_4 {
        width: 100%;
        background: url('https://global-cdn.imscv.com/tewamoto%2FM260612%2FDealer_bg_MB_2%C3%97.jpg') no-repeat;
        background-size: 100% 100%;
        font-family: "AlibabaPuHuiTi";
        color: #fff;
        text-align: center;
        box-sizing: border-box;
        padding: 50px 20px 150px;

        .t1 {
          font-weight: bold;
          font-size: 20px;
        }

        .t2 {
          opacity: .8;
          font-size: 8px;
          line-height: 9px;
        }

        .icon_list {
          margin: 30px 0;
          display: grid;
          grid-template-columns: repeat(6, 1fr);
          gap: 20px;

          .list_item {
            display: flex;
            flex-direction: column;
            align-items: center;

            img {
              width: 30px;
              height: 30px;
            }

            div {
              font-size: 8px;
              opacity: .8;
            }
          }

          /* 前2个占 3列 = 第一行2个 */
          .list_item:nth-child(1),
          .list_item:nth-child(2) {
            grid-column: span 3;
          }

          /* 后3个占 2列 = 第二行3个 */
          .list_item:nth-child(n+3) {
            grid-column: span 2;
          }
        }

        .btn_box {
          display: flex;
          justify-content: space-between;
          column-gap: 10px;

          div {
            flex: 1;
            color: #000;
            font-weight: bold;
            text-align: center;
            padding: 5px 2px;
            font-size: 14px;       // 平分半宽下继承 16px 会换行，14px 可完整显示
            white-space: nowrap;   // 禁止 ">" 被挤到第二行
          }

          .btn_l {
            background-color: #FFA400;
          }

          .btn_r {
            background-color: #fff;
          }
        }
      }
    }
  }
</style>